/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import Loading from '../../../common/Loading';

import './index.scss';

Modal.setAppElement('#root');

class CreateWebhook extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      url: '',
      challenge:''
    };
  }

  componentDidMount() {
    console.log('this.props', this.props);
    if (this.props.formresponse.webhook?.webhook_url) {
      this.setState({
        url: this.props.formresponse.webhook?.webhook_url
      })
    } else if(!this.props.edit){
      this.setState({
        url: '',
        challenge: ''
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    console.log('this.props 1', nextProps);
    if (this.props.formresponse.webhook?.webhook_url !== nextProps.formresponse.webhook?.webhook_url) {
      this.setState({
        url: nextProps.formresponse.webhook?.webhook_url,
        challenge: ''
      })
    }
  }
  
  closeModal() {
    this.props.closeModel();
  }

  handleChange = (event) => {
    console.log('event', event);
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  postWebhook = () => {
    const { url, challenge } = this.state;
    const { business , auth} = this.props;
    console.log('business', business, auth);
    const business_id = this.props.business.id || auth.studio_id;
    const webhook = {
      "webhook_url": url,
      "webhook_challenge": challenge,
      "events": ["LEAD_ENGAGE_NOTIFICATION"]
    }
    this.props.postupdateWebHook(webhook, business_id);
  }
  
  render() {
    const { modelopen, isLoading, edit } = this.props;
    console.log('formresponse',this.props.formresponse);
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">{edit ? 'Update webhook' : 'Create new webhook'}</div>
              <button className="modal-close" onClick={this.closeModal}>
                X
              </button>
              {isLoading ?
                (<div className="add-campaign_loader">
                  <Loading />
                </div>) : (<>

                  <div className="input">
                    <label className="label">NOTIFICATION WEBHOOK URL</label>
                    <input
                      type="text"
                      name="url"
                      placeholder="Add webhook url here"
                      value={this.state.url}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="input">
                    <label className="label">WEBHOOK CHALLENGE</label>
                    <input
                      type="text"
                      name="challenge"
                      placeholder="Add webhook challenge here"
                      value={this.state.challenge}
                      onChange={this.handleChange}
                      maxlength="100"
                    />
                  </div>
                  <div className="note">
                    This is where TrueLark will send Lead Engage Notifications via webhook. Please note, this is <span className="bold-section">not the same</span> webhook as the Lead Engage campaign webhook which you use to send leads to Lead Engage.
                  </div>
                  <div className="actions">
                    <button
                      className="btn btn--primary btn--lg"
                      onClick={this.postWebhook}
                      disabled={this.state.url.trim().length < 1 || this.state.challenge.trim().length < 1}
                    >
                      SAVE
                    </button>
                    <button
                      className="btn btn--secondary btn--lg"
                      onClick={this.closeModal}
                    >
                      CANCEL
                    </button>
                  </div>

                </>)}
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default CreateWebhook;
